import { alpha, useTheme, type SxProps, type Theme } from "@mui/material";

const useNewSymbolDialogStyles = () => {
  const theme = useTheme();

  return {
    paper: {
      borderRadius: "32px",
    } as SxProps<Theme>,

    title: {
      gap: "16px",
      pl: "24px",
      pr: "12px",
      py: "24px",
    } as SxProps<Theme>,

    titleText: {
      fontSize: "18px",
      lineHeight: "28px",
      fontWeight: 400,
    } as SxProps<Theme>,

    closeButton: {
      width: "28px",
      height: "28px",
      color: theme.palette.text.disabled,
    } as SxProps<Theme>,

    content: {
      px: "24px",
      pt: 0,
      pb: "16px",
    } as SxProps<Theme>,

    actions: {
      px: "24px",
      py: "24px",
      gap: "12px",
    } as SxProps<Theme>,

    body: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    } as SxProps<Theme>,

    headerRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
    } as SxProps<Theme>,

    counterWrap: {
      flex: 1,
      minWidth: 0,
    } as SxProps<Theme>,

    counterText: {
      color: theme.palette.text.secondary,
    } as SxProps<Theme>,

    counterNumber: {
      color: theme.palette.primary.main,
    } as SxProps<Theme>,

    captionText: {
      display: "block",
      color: theme.palette.text.disabled,
    } as SxProps<Theme>,

    uploadButton: {
      height: "30px",
      flexShrink: 0,
      bgcolor: alpha(theme.palette.primary.main, 0.08),
      color: theme.palette.primary.dark,
      "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.16) },
    } as SxProps<Theme>,

    emptyStateRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      bgcolor: theme.palette.background.neutral,
      borderRadius: "8px",
      pl: "4px",
      py: "4px",
      pr: 2,
    } as SxProps<Theme>,

    emptyStateIconBox: {
      width: 48,
      height: 48,
      flexShrink: 0,
      borderRadius: "8px",
      bgcolor: alpha(theme.palette.warning.main, 0.16),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    } as SxProps<Theme>,

    emptyStateText: {
      color: theme.palette.text.primary,
    } as SxProps<Theme>,

    rowCard: {
      position: "relative",
      display: "flex",
      gap: 1,
      alignItems: "flex-start",
      bgcolor: alpha(theme.palette.grey[500], 0.08),
      borderRadius: "12px",
      p: 2,
    } as SxProps<Theme>,

    rowImage: {
      width: 48,
      height: 48,
      flexShrink: 0,
      borderRadius: "12px",
      objectFit: "cover",
      bgcolor: theme.palette.grey[300],
    } as SxProps<Theme>,

    descriptionField: {
      flex: 1,
    } as SxProps<Theme>,

    codeField: {
      width: "126px",
      flexShrink: 0,
    } as SxProps<Theme>,

    rowDeleteButton: {
      position: "absolute",
      top: "-8px",
      right: "-8px",
      width: "28px",
      height: "28px",
      bgcolor: alpha(theme.palette.error.main, 0.08),
      "&:hover": { bgcolor: alpha(theme.palette.error.main, 0.16) },
    } as SxProps<Theme>,

    deleteIcon: {
      width: 18,
      height: 18,
    },

    colors: {
      upload: theme.palette.primary.dark,
      warning: theme.palette.warning.main,
      delete: theme.palette.error.main,
    },
  };
};

export default useNewSymbolDialogStyles;
